export default __webpack_public_path__ + "static/media/brightness_alert.9b3fb1d5.svg";